import styled from 'styled-components';
import { font } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const Card = styled.div<{ theme: Theme }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 16px;
  background-color: ${getColor('textWhite')};
  border: 1px solid ${getColor('textTertiary')};
  box-shadow: 0px 0px 20px ${getColor('neutralBlack')}19;
  border-radius: 4px;
  z-index: 2;

  &:hover {
    box-shadow: 4px 4px 20px 0px ${getColor('textPrimary')}40;

    .title {
      color: ${getColor('textAccentPrimary')};
    }
  }

  &:focus,
  &:active {
    box-shadow: 0px 0px 7px 0px ${getColor('shadeBrandPrimary900')};

    .title {
      color: ${getColor('textSecondary')};
    }
  }
`;

export const CardHeader = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${getColor('borderPrimary')};
`;

export const CardContent = styled.div`
  font-family: ${font.graphikCond};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;

  .crash-course-image {
    aspect-ratio: 299 / 203;
  }

  .learn-more-link {
    display: flex;
    align-self: flex-end;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0;
    text-transform: uppercase;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 1;
    }
  }
`;

export const Description = styled.p<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' })};
`; // When changing this font-size update line 44 from src/main/components/CrashCourseMasonry/index.tsx
